import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { MatTreeModule } from '@angular/material/tree';
import { DragDropDirective } from '../../directives/drag-drop.directive';

import { InputFieldComponent } from './input-field/input-field.component';
import { SelectFieldComponent } from './select-field/select-field.component';
import { MultiSelectFieldComponent } from './multi-select-field/multi-select-field.component';
import { TextareaFieldComponent } from './textarea-field/textarea-field.component';
import { CheckboxFieldComponent } from './checkbox-field/checkbox-field.component';
import { RadioFieldComponent } from './radio-field/radio-field.component';
import { RmsDateComponent } from './date-field/date-field.component';
import { NumberFieldComponent } from './number-field/number-field.component'
import { RmsPopupComponent } from './rms-popup/rms-popup.component';
import { RmsToggleComponent } from './rms-toggle/rms-toggle.component';
import { RmsModComponent } from './rms-mod/rms-mod.component'
import { RmsTableComponent } from './rms-table/rms-table.component'
import { RmsTabGroupComponent } from './rms-tab-group/rms-tab-group.component';
import { RmsTabComponent } from './rms-tab/rms-tab.component';
import { RmsSearchSelectComponent } from './rms-search-select/rms-search-select.component';
import { DateRangeSliderComponent } from './date-range-slider/date-range-slider.component';
import { RmsPromptComponent } from './rms-prompt/rms-prompt.component';
import { RmsUploaderComponent } from './rms-uploader/rms-uploader.component';
import { RmsFilterBarComponent } from './rms-filter-bar/rms-filter-bar.component';
import { RmsStepperComponent } from './rms-stepper/rms-stepper.component';
import { RmsStepComponent } from './rms-stepper/rms-step.component';
import { RmsFilePreviewComponent } from './rms-file-preview/rms-file-preview.component';
import { RmsFileExplorerComponent } from './rms-file-explorer/rms-file-explorer.component';
import { RmsSliderComponent } from './rms-slider/rms-slider.component';
import { RmsDataSliderComponent } from './rms-data-slider/rms-data-slider.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    InputFieldComponent,
    SelectFieldComponent,
    MultiSelectFieldComponent,
    TextareaFieldComponent,
    CheckboxFieldComponent,
    RadioFieldComponent,
    RmsDateComponent,
    NumberFieldComponent,
    RmsPopupComponent,
    RmsToggleComponent,
    RmsModComponent,
    RmsTableComponent,
    RmsTabGroupComponent,
    RmsTabComponent,
    FormsModule,
    RmsSearchSelectComponent,
    MatButtonModule,
    MatIconModule,
    DateRangeSliderComponent,
    RmsPromptComponent,
    RmsUploaderComponent,
    RmsFilterBarComponent,
    MatMenuModule,
    MatStepperModule,
    ReactiveFormsModule,
    RmsFilePreviewComponent,
    RmsFileExplorerComponent,
    MatTreeModule,
    DragDropDirective,
    RmsSliderComponent,
    RmsDataSliderComponent
  ],
  exports: [
    CommonModule,
    InputFieldComponent,
    SelectFieldComponent,
    MultiSelectFieldComponent,
    TextareaFieldComponent,
    CheckboxFieldComponent,
    RadioFieldComponent,
    RmsDateComponent,
    NumberFieldComponent,
    RmsPopupComponent,
    RmsToggleComponent,
    RmsModComponent,
    RmsTableComponent,
    RmsTabGroupComponent,
    RmsTabComponent,
    FormsModule,
    RmsSearchSelectComponent,
    MatButtonModule,
    MatIconModule,
    DateRangeSliderComponent,
    RmsPromptComponent,
    RmsUploaderComponent,
    RmsFilterBarComponent,
    MatMenuModule,
    MatStepperModule,
    ReactiveFormsModule,
    RmsFilePreviewComponent,
    RmsFileExplorerComponent,
    MatTreeModule,
    DragDropDirective,
    RmsSliderComponent,
    RmsDataSliderComponent
  ]
})
export class RmsModule { }
